import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { Cookies } from 'react-cookie';

const checkIspmFeatureFlag = async () => {
  try {

    // Create cookies instance inside function for better testability and fresh state
    const cookies = new Cookies();
    const token = cookies.get('access_token');
    const tokenType = cookies.get('token_type');

    const response = await fetch('/ECMv6/api/ispm/v1/config?moduleName=ispm&key=mfe_enabled', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...(token
            ? {
                Authorization: `${tokenType || 'Bearer'} ${token}`,
              }
            : {}),
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    const data = await response.json();
    return data?.data?.value === 'true';
  } catch (error) {
    console.warn('ISPM feature flag check failed:', error.message);
    throw error;
  }
};

const useIspmFeatureFlag = () => {
  const { ISPM_SERVICES_ENABLED } = useSelector(state => state.user.domainInfo || {});

  const { data: isMfeEnabled = false, isLoading, isError, error } = useQuery({
    queryKey: ['ispm-feature-flag'],
    queryFn: checkIspmFeatureFlag,
    enabled: !!ISPM_SERVICES_ENABLED,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * Math.pow(2, attemptIndex), 5000)
  });

  return {
    isMfeEnabled: ISPM_SERVICES_ENABLED ? isMfeEnabled : false,
    isLoading: ISPM_SERVICES_ENABLED ? isLoading : false,
    isError,
    error
  };
};

export default useIspmFeatureFlag;